module.exports = __webpack_public_path__ + "img/Trillionaire-5.fc2e6c8c.gif";